// Module
var code = "<p class=\"circle\">4</p> <p>Enter or choose your payment information.</p> ";
// Exports
export default code;